import type { TState, Toast as BSToast } from '../definitions'
import getBootstrapApi from '../getBootstrapApi'

import styles from './Toast.scss'

const TOASTS_CONTAINER_ID = 'toasts-container'

interface IProps {
  readonly state?: Exclude<TState, 'light' | 'dark' | 'link'>
  readonly head?: string
  readonly yPosition?: 'bottom' | 'top'
  readonly body?: string
  readonly delay?: number
  readonly isInstantVisible?: boolean
}

/**
 * Visszaad egy bootstrap toast-ot, amit a mi igényeink szerint továbbfejlesztettünk.
 * @param props - Props {@link IProps}.
 */
export default function Toast (props: IProps): BSToast {
  let container: HTMLElement | null = document.querySelector(`#${ TOASTS_CONTAINER_ID }`)

  if (!container) {
    container = (
      <div
        id={ TOASTS_CONTAINER_ID }
        className={ [ 'position-fixed', 'end-0', 'p-3' ] }
        style={ { zIndex: '2000' } }
      />
    ) as HTMLElement

    document.body.appendChild(container)
  }

  container.classList.remove('bottom-0', 'top-0')

  const yPos = props.yPosition ? `${ props.yPosition }-0` : 'bottom-0'
  container.classList.add(yPos)

  const className: string[] = [
    'toast',
    'mb-3',
    styles.toast,
    styles[props.state ?? 'primary']
  ]

  const toast: HTMLElement = (
    <div
      className={ className }
      aria-atomic="true"
      aria-live="assertive"
      role="alert"
      data-bs-delay={ props.delay ?? 0 }
    >
      <div className="toast-header">
        <strong className="me-auto">{ props.head }</strong>
        <button className="btn-close" aria-label="Close" type="button" data-bs-dismiss="toast" />
      </div>

      <div className="toast-body">
        { props.body }
      </div>
    </div>
  )

  container.appendChild(toast)

  const bsApi = getBootstrapApi()

  const api = new bsApi.Toast(toast)

  if (props.isInstantVisible) {
    api.show()
  }

  return api
}
